import React from 'react';
import Img from 'react-image';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';

import styles from './areas.module.scss';
import starImg from '../../img/star.png';

import CcuArg11 from '../../img/CCU_Arg-11.png';
import CcuArg12 from '../../img/CCU_Arg-12.png';
import CcuArg13 from '../../img/CCU_Arg-13.png';
import CcuArg14 from '../../img/CCU_Arg-14.png';
import CcuArg15 from '../../img/CCU_Arg-15.png';
import CcuArg16 from '../../img/CCU_Arg-16.png';
import CcuArg17 from '../../img/CCU_Arg-17.png';
import CcuArg18 from '../../img/CCU_Arg-18.png';

let cx = classNames.bind(styles);

const Areas = () => {
	const { t } = useTranslation();

	return (
		<section id='areas' className={cx({ areas: true })}>
			<div className='container mx-auto flex flex-col my-4'>
				<div className='flex flex-col text-ccu-green w-full mb-8 pl-8'>
					<p className='text-ccu-dark text-2xl font-bold leading-tight pl-10'>
						Nuestras
					</p>
					<h1 className='text-6xl font-bold leading-none font-Ubuntu-Bold '>Áreas</h1>
				</div>
				<div className='flex flex-col lg:flex-row lg:mb-8 '>
					<div className='flex flex-col w-full lg:w-1/2'>
						<div className='flex flex-row w-full my-0 lg:my-4'>
							<div
								className={cx({
									box: true,
									'w-4/12 lg:w-2/12 bg-ccu-yellow flex flex-col justify-center items-center': true,
								})}
							>
								<Img src={CcuArg15} className='w-full' />
							</div>
							<div className='w-8/12 lg:w-10/12 py-0 px-4 lg:pr-32 flex items-center'>
								<h1 className='text-ccu-dark-green text-2xl font-bold font-Roboto-Bold'>
									Administración y Finanzas
								</h1>
							</div>
						</div>
						<div className='flex flex-row w-full my-0 lg:my-4 lg:pl-4'>
							<div
								className={cx({
									box: true,
									'w-4/12 lg:w-2/12 bg-ccu-green flex flex-col justify-center items-center': true,
								})}
							>
								<Img src={CcuArg14} className='w-full' />
							</div>
							<div className='w-8/12 lg:w-10/12 py-0 px-4 lg:pr-20 flex items-center'>
								<h1 className='text-ccu-dark-green text-2xl font-bold font-Roboto-Bold'>
									Asuntos Legales
								</h1>
							</div>
						</div>
						<div className='flex flex-row w-full my-0 lg:my-4 lg:pl-8'>
							<div
								className={cx({
									box: true,
									'w-4/12 lg:w-2/12 bg-ccu-red flex flex-col justify-center items-center': true,
								})}
							>
								<Img src={CcuArg16} className='w-full' />
							</div>
							<div className='w-8/12 lg:w-10/12 py-0 px-4 lg:pr-20 flex items-center'>
								<h1 className='text-ccu-dark-green text-2xl font-bold font-Roboto-Bold'>
									Recursos Humanos
								</h1>
							</div>
						</div>
						<div className='flex flex-row w-full my-0 lg:my-4 lg:pl-12'>
							<div
								className={cx({
									box: true,
									'w-4/12 lg:w-2/12 bg-ccu-blue flex flex-col justify-center items-center': true,
								})}
							>
								<Img src={CcuArg17} className='w-full' />
							</div>
							<div className='w-8/12 lg:w-10/12 py-0 px-4 lg:pr-12 flex items-center'>
								<h1 className='text-ccu-dark-green text-2xl font-bold font-Roboto-Bold'>
									Marketing, Sidras & Vino
								</h1>
							</div>
						</div>
					</div>

					<div className='flex flex-col w-full lg:w-1/2 lg:pt-12'>
						<div className='flex flex-row w-full my-0 lg:my-4'>
							<div
								className={cx({
									box: true,
									'w-4/12 lg:w-2/12 bg-ccu-green flex flex-col justify-center items-center': true,
								})}
							>
								<Img src={CcuArg18} className='w-full' />
							</div>
							<div className='w-8/12 lg:w-10/12 py-0 px-4 lg:pr-10 flex items-center'>
								<h1 className='text-ccu-dark-green text-2xl font-bold font-Roboto-Bold'>
									Industrial
								</h1>
							</div>
						</div>
						<div className='flex flex-row w-full my-0 lg:my-4 lg:pl-4'>
							<div
								className={cx({
									box: true,
									'w-4/12 lg:w-2/12 bg-ccu-red flex flex-col justify-center items-center': true,
								})}
							>
								<Img src={CcuArg12} className='w-full' />
							</div>
							<div className='w-8/12 lg:w-10/12 py-0 px-4 lg:pr-12 flex items-center'>
								<h1 className='text-ccu-dark-green text-2xl font-bold font-Roboto-Bold'>
									Logística y Planificación
								</h1>
							</div>
						</div>
						<div className='flex flex-row w-full my-0 lg:my-4 lg:pl-8'>
							<div
								className={cx({
									box: true,
									'w-4/12 lg:w-2/12 bg-ccu-yellow flex flex-col justify-center items-center': true,
								})}
							>
								<Img src={CcuArg11} className='w-full' />
							</div>
							<div className='w-8/12 lg:w-10/12 py-0 px-4 lg:pr-0 flex items-center'>
								<h1 className='text-ccu-dark-green text-2xl font-bold font-Roboto-Bold'>
									Asuntos Corporativos
								</h1>
							</div>
						</div>
						<div className='flex flex-row w-full my-0 lg:my-4 lg:pl-12'>
							<div
								className={cx({
									box: true,
									'w-4/12 lg:w-2/12 bg-ccu-blue flex flex-col justify-center items-center': true,
								})}
							>
								<Img src={CcuArg13} className='w-full' />
							</div>
							<div className='w-8/12 lg:w-10/12 py-0 px-4 lg:pr-6 flex items-center'>
								<h1 className='text-ccu-dark-green text-2xl font-bold font-Roboto-Bold'>
									Ventas
								</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Areas;
